"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HintText = exports.LabelText = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.LabelText = styled_components_1.default.span(function (_a) {
    var _b = _a.theme, field = _b.field, mediaQueries = _b.mediaQueries;
    return "\n    font-family: ".concat(field.fontFamily, ";\n    line-height: ").concat(field.lineHeight, ";\n    display: block;\n    font-weight: ").concat(field.label.fontWeight, ";\n    color: ").concat(field.label.color, ";\n    font-size: ").concat(field.fontSize[0], ";\n\n    ").concat(mediaQueries.smallAndUp, " {\n      font-size: ").concat(field.fontSize[1], ";\n    }\n  ");
});
exports.HintText = (0, styled_components_1.default)(exports.LabelText)(function (_a) {
    var field = _a.theme.field;
    return "\n    font-weight: ".concat(field.hint.fontWeight, ";\n    color: ").concat(field.hint.color, ";\n  ");
});
